import { Label } from "semantic-ui-react"
import Price from "components/Price/Price"
import React from "react"


const ProductPrice = ( { product, className = "pb4 pt2 relative lh-solid" } ) => {
  return <div className={`ProductPrice ${className}`}>
    {product.isSale &&
    <div className="price ">
      <Label color="red">{product.salePercent}</Label>
      {/*<div className="unit_multi black-70 f6 pb2 fw2">Stückpreis</div><br/>*/}
      <div className="f4 red b"><Price>{product.price}</Price> <span className="f5 black-60 fw4 pb1 strike "><Price>{product.pinfos.brutto}</Price></span></div>
      <div className="pt2 black-40 f5 fw6 lh-solid">{translate("PRICE_PREFIX")} {product.baseUnitDisplayName || product.extras.veextrainfo || translate( "Stück" )}</div>
    </div>}
    {!product.isSale &&
    <div className="price lh-solid">
      <div className="f2 fw6"><Price>{product.price}</Price> {product.salePercent &&
      <span className={"black-60 f5 fw6"}>(<Price>{product.originalPrice}</Price> {translate("abzgl.")} {product.salePercent} {translate("Rabatt")})</span>}
      </div>
      <div className="pt2 black-40 f5 fw6 lh-solid">{translate("PRICE_PREFIX")} {product.baseUnitDisplayName ||  product.extras.veextrainfo || translate( "Stück" )}</div>
    </div>}

    {/*{(product.isSale && product.quantities.length > 1) &&*/}
    {/*<div className="price ">*/}
    {/*  /!*<div className="unit_multi black-70 f6 pb2 fw2">Stückpreis</div><br/>*!/*/}
    {/*  <div className="f5 black-60 strike"><Price>{product.price * product.unit_multi}</Price></div>*/}
    {/*  <div className="f4 red b"><Price>{product.price}</Price></div>*/}
    {/*</div>}*/}
    {/*{(!product.isSale && product.quantities.length > 1) &&*/}
    {/*<div className="price color lh-solid pt2 ">*/}
    {/*  <div className="f3  b"><Price>{product.price * product.unit_multi}</Price></div>*/}
    {/*  <div className=" black-70 f6 fw2 lh-solid">{translate( "VE Preis" )} ({product.unit_multi} {translate( "Stück" )})</div>*/}
    {/*</div>}*/}
  </div>
}

export default ProductPrice


// WEBPACK FOOTER //
// ./src/theme/lucht-test/components/Product/ProductPrice.js